<template>
  <v-dialog
    v-model="show"
    overlay-color="darktext"
    overlay-opacity="0.6"
    max-width="400"
    content-class="dialog-withlink"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        {{ cdText }}
      </v-card-text>
      <div
        v-for="idp in idps"
        :key="idp.name"
        class="text-right"
      >
        <v-card-actions
          v-if="idp.enabled && idp.configured_properly"
          class="flex-column flex-sm-column px-6 py-0 flex-md-row align-end"
          style="display: inherit;"
        >
          <v-btn
            data-testid="saml-submit-button"
            type="submit"
            class="rounded-xxl text-none greytext--text px-4"
            @click="samlLoginUser(idp.name)"
          ><v-icon class="mr-2" color="greytext">mdi-cloud-outline</v-icon>
            {{ idp.button_text }}
          </v-btn>
        </v-card-actions>
      </div>
      <v-card-actions class="flex-column  flex-sm-column px-6 flex-md-row align-end">
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          :color="cdCancelBtnColor"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 mb-2 mb-md-0"
          @click="show=false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          :color="cdSubmitBtnColor"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4"
          @click="submitDialogBtn(id)"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
        
      <v-card-actions class="pt-0">
        <v-spacer />
        <a
          ref="submit"
          data-testid="link-button"
          min-width="100"
          class="text-decoration-none text-none text-body-2 mx-4 darktext--text"
          @click="LinkDialogBtn(id)"
        > {{ cdLinkBtn }} </a>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '../plugins/i18n';
import { samlLoginUser } from '../api/userApi'

export default {
  props: {
    visible: Boolean,
    id: {
      type: Number,
      default: 0
    },
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
    cdLinkBtn: {
      type: String,
      default: ''
    },
    cdSubmitBtnColor: {
        type: String,
        default: 'error'
    },
    cdCancelBtnColor: {
        type: String,
        default: 'darktext'
    },
    cdEntityId: {
        type: String,
        default: null
    },
    cdEntityType: {
        type: String,
        default: null
    },
    cdIdps: {
        type: Array,
        default: () => []
    },
  },
  data () {
      return {
        idps: this.cdIdps,
        space: window.location.host.split('.')[0],
      }
  },
  computed: {
    show: {
      get () {
        return this.visible        
      },
      set (value) {
        if (!value) {
          this.$emit('close')          
        }
         
      }
    }
  },
  methods: {
    submitDialogBtn(id) {
      this.$emit('proceedSubmit', id)
    },
      LinkDialogBtn(id) {
      this.$emit('proceedLink', id)
    },
    closeDialog() {
        this.$emit('clickOutSide', false);
    },
    async samlLoginUser(idpName){
      try {
        let redirect = ''
        if (this.space) {
          redirect = process.env.VUE_APP_PROTOCOL + "://" + this.space + "." + process.env.VUE_APP_DOMAIN + "/saml-login"
        }

        const response = await samlLoginUser(idpName, redirect, this.space + '.' + process.env.VUE_APP_DOMAIN + "/" + this.cdEntityType + "/" + this.cdEntityId)
        if (response.status == 200) {
            window.open(response.data.url, "_self");
        }
      } catch (e) {
      if(e.response){
        if(e.response.status == 403){
            this.$router.push('/forbidden')
          }
        }
      }
    },
  },
}
</script>